import httpRequest from "Utilities/SetAuthToken";
import ApiUrls from "Definations/ApiUrls";

export async function dashboardAnalytics(isFiltered?: any): Promise<any> {
    const url = isFiltered ? `${ApiUrls.getDashboardAnalytics}${isFiltered}` : ApiUrls.getDashboardAnalytics;
    return httpRequest.get(`${url}`);
}

export async function getProcessedSOVsList(page: number): Promise<any> {
    return httpRequest.get(`${ApiUrls.workbookHistories}`, {
        params: { page, page_size: 10 }
    });
}

export async function getSubsciptionList(page: number): Promise<any> {
    return httpRequest.get(`${ApiUrls.subscriptions}`, {
        params: { page }
    });
}

export async function getCompaniesList(): Promise<{ data: { company_names: string[] } }> {
    return httpRequest.get(`${ApiUrls.companiesList}`);
}

export async function getAProcessedSOV(workbookId: number | null): Promise<any> {
    return httpRequest.get(`${ApiUrls.workbookHistories}/${workbookId}`);
};

export async function getTriageDataListing(params?: string): Promise<any> {
    return httpRequest.get(`${ApiUrls.triageListing}${params}`);
};

export async function getInvoiceByCompany(params?: string): Promise<any> {
    return httpRequest.get(`${ApiUrls.companyInvoice}${params}`);
};
